import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5901a5be&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5901a5be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../email/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5901a5be",
  null
  
)

export default component.exports